import React, { useState, useRef, useEffect } from "react";
import dropdown_custom from "../../../assets/icons/dropdown_custom.svg";

const Dropdown = ({
  data,
  value = [],
  onChange,
  multiSelect = false,
  bgColor = "#fff",
  textColor = "#252C58",
  fontSize = "12px",
  fontWeight = "500",
  lineHeight = "20px",
  textAlign = "left",
  clearSection,
  hide,
  type,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (selectedValue) => {
    if (multiSelect) {
      const newValue = value.some((v) => v.value === selectedValue.value)
        ? value.filter((v) => v.value !== selectedValue.value)
        : [...value, selectedValue];

      onChange(newValue);
      // Update the selected values based on the changes
    } else {
      onChange(selectedValue);
      setIsOpen(false);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    clearSection([]);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  // const handleSelectChange = (selectedValue) => {
  //   if (multiSelect) {
  //     const newValue = value.some((v) => v.value === selectedValue.value)
  //       ? value.filter((v) => v.value !== selectedValue.value)
  //       : [...value, selectedValue];

  //     if (newValue.length === 0) {
  //       // If no items are selected, uncheck "All"
  //       handleSelectAll();
  //     } else {
  //       onChange(newValue);
  //     }
  //   }
  // };

  const handleSelectAll = () => {
    if (data?.length > 0) {
      if (value.length === data?.filter((data) => !data?.disabled).length) {
        // Deselect all items
        onChange([]);
      } else {
        const datas = data?.filter((data) => !data?.disabled);

        onChange(datas); // This will set all items as selected
      }
    }
  };

  const handleSelectChange = (selectedValue) => {
    if (multiSelect) {
      const newValue = value.some((v) => v.value === selectedValue.value)
        ? value.filter((v) => v.value !== selectedValue.value)
        : [...value, selectedValue];

      if (newValue.length === 0) {
        // If no items are selected, uncheck "All"
        handleSelectAll();
      } else {
        onChange(newValue);
      }
    } else {
      onChange(selectedValue);
    }
  };

  const isAllSelected =
    value.length === data?.filter((data) => !data?.disabled).length;

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      style={{
        backgroundColor: bgColor,
        border: "1px solid #F0F0F0",
        color: textColor,
        fontSize: fontSize,
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        textAlign: textAlign,
        padding: "0 10px",
        width: "200px",
        borderRadius: "4px",
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {type !== "input" ? (
        <p
          onClick={toggleDropdown}
          style={{
            cursor: "pointer",
            padding: "2px 6px",
            height: "31px",
            overflow: "hidden",
            width: "80%",
          }}
        >
          {Array.isArray(value) && value.length > 0
            ? value
                .map((id) => {
                  const company = data?.find((item) => item.value == id?.value);
                  return company ? company.label : null; // Show label instead of value
                })
                .filter(Boolean) // Remove null values
                .join(", ")
            : value && value.length == 0
            ? "Select an option"
            : value}
        </p>
      ) : (
        <input
          type="text"
          style={{
            padding: "5px",
            backgroundColor: bgColor,
            border: "none",
            color: textColor,
            fontSize: fontSize,
            fontWeight: fontWeight,
            lineHeight: lineHeight,
            textAlign: textAlign,
            outline: "none",
            display: "flex",
            alignItems: "center",
            flexGrow: 1,
          }}
          placeholder="Search"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      )}

      {type !== "input" && !hide && value.length > 0 && (
        <svg
          width="25"
          height="30"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={handleClear}
          style={{ marginRight: "2px" }}
        >
          <rect
            width="60"
            height="60"
            rx="30"
            fill="#2C357D"
            fillOpacity="0.15"
          />
          <path
            d="M37.75 22.1377L21.25 38.6377"
            stroke="#2C357D"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.25 22.1377L37.75 38.6377"
            stroke="#2C357D"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}

      {type !== "input" && (
        <img
          src={dropdown_custom}
          alt="dropdown icon"
          style={{ cursor: "pointer" }}
          onClick={toggleDropdown}
        />
      )}

      {isOpen && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "#fff",
            color: textColor,
            margin: 0,
            padding: 0,
            listStyle: "none",
            border: "1px solid #F0F0F0",
            boxShadow: "0px 4px 4px 0px #00000040",
            zIndex: 100,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {multiSelect && (
            <li
              onClick={value?.length > 0 ? handleSelectAll : undefined}
              style={{
                padding: "10px",
                cursor: "pointer",
                backgroundColor: "#fff",
                color: textColor,
                fontSize: fontSize,
                fontWeight: fontWeight,
                lineHeight: lineHeight,
                textAlign: textAlign,
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
                style={{ marginRight: "8px" }}
              />
              All
            </li>
          )}
          {data?.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelectChange(item)}
              style={{
                padding: "10px",
                cursor: item?.disabled ? "not-allowed" : "pointer",
                backgroundColor: item?.disabled ? "#f0f0f0" : "#fff",
                color: item?.disabled ? "#b0b0b0" : textColor,
                fontSize: fontSize,
                fontWeight: fontWeight,
                lineHeight: lineHeight,
                textAlign: textAlign,
                display: "flex",
                alignItems: "center",
              }}
            >
              {multiSelect && (
                <input
                  type="checkbox"
                  checked={value.some((v) => v.value === item.value)}
                  onChange={() => handleSelectChange(item)}
                  style={{ marginRight: "8px" }}
                  disabled={item?.disabled}
                />
              )}
              {item.label || "Select"}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
